import type { QueryClient } from "@tanstack/react-query";
import { useSchoolLayoutData } from "#/modules/generic.user/use-schools";
import { VakantiesDialog } from "#/modules/les.planning/components/vakanties-dialog";
import { vakantiesQueryOptions } from "#/modules/les.planning/query.planning";

// The vakanties dialog as a route, shared by every page it opens over: each page has its own
// `vakanties` child route, and closing goes back to that page as it was.

export const vakantiesRouteOptions = {
  staticData: { overlay: true },
  loader: ({
    context,
    params: { school, schoolyear },
  }: {
    context: { queryClient: QueryClient };
    params: { school: string; schoolyear?: string };
  }) => context.queryClient.ensureQueryData(vakantiesQueryOptions({ school, schoolyear })),
};

export function VakantiesRouteDialog({
  params,
  onClose,
}: {
  params: { school: string; schoolyear?: string };
  onClose: () => void;
}) {
  const schoolName = useSchoolLayoutData()?.schoolName ?? params.school;
  return (
    <VakantiesDialog
      tenant={{ school: params.school, schoolyear: params.schoolyear }}
      schoolName={schoolName}
      onClose={onClose}
    />
  );
}
